import type {ContentCategory} from '@/ts/types/dto/home-dto';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';
import type {SideBarGroupedSection,SideBarSectionItem} from '@/ts/types/component/balm-sidebar';

/** Content item with a unique ID and associated category */
export interface Item {
  id: UuidDTO;
  category: ContentCategory;
}

/** Named group of items identified by a UUID */
export interface OutComeItem<T> {
  id: UuidDTO;
  name: string;
  items: T[];
}

/** Groups content items by their category and maps them into sidebar section format */
export function groupByCategory<T extends Item>(items: T[], itemMapper: (item: T) => SideBarSectionItem): SideBarGroupedSection[] {
  const mapped: Record<UuidDTO, T[]> = {};
  for (const gloss of items) {
    if (!mapped[gloss.category.id]) {
      mapped[gloss.category.id] = [];
    }
    mapped[gloss.category.id].push(gloss);
  }
  return Object.entries(mapped).map(([key, value]) => {
    return {
      id: key as UuidDTO,
      name: value[0].category.name,
      items: value.map(itemMapper),
    };
  });
}
